<template>
  <header id="header" class="header d-flex align-items-center fixed-top">
    <div class="container position-relative d-flex align-items-center justify-content-between">

      <RouterLink to="/" class="logo-wrapper me-auto me-xl-0">
        <div class="logo-circle">
          <img src="@/assets/img/Tactical/ApexLogo.png" alt="Apex Logo" />
        </div>
      </RouterLink>

      <nav id="navmenu" class="navmenu">
        <ul>
          <li>
            <RouterLink to="/" exact-active-class="active">Inicio</RouterLink>
          </li>
          <li>
            <RouterLink to="/live-training" active-class="active">Presencial</RouterLink>
          </li>
          <li>
            <RouterLink to="/virtual-training" active-class="active">En Línea</RouterLink>
          </li>

          <li class="logo-spacer d-none d-xl-block"></li>

          <li>
            <RouterLink to="/shop" active-class="active">Tienda</RouterLink>
          </li>
          <li>
            <RouterLink to="/tactical-games" active-class="active">Combate Funcional</RouterLink>
          </li>
          <li>
            <RouterLink to="/about-us" active-class="active">Acerca de</RouterLink>
          </li>
        </ul>
        <i class="mobile-nav-toggle d-xl-none bi bi-list"></i>
      </nav>
    </div>
  </header>
</template>

<script setup>
import { onMounted, onUnmounted } from "vue";

let scrollHandler = null;

onMounted(() => {
  const body = document.body;
  const header = document.querySelector("#header");
  const toggleBtn = document.querySelector(".mobile-nav-toggle");

  if (!header) return;

  scrollHandler = () => {
    if (window.scrollY > 80) {
      header.classList.add("scrolled-header");
    } else {
      header.classList.remove("scrolled-header");
    }
  };

  window.addEventListener("scroll", scrollHandler, { passive: true });
  window.addEventListener("load", scrollHandler);

  const toggleMobileNav = () => {
    body.classList.toggle("mobile-nav-active");
    toggleBtn?.classList.toggle("bi-list");
    toggleBtn?.classList.toggle("bi-x");
  };

  toggleBtn?.addEventListener("click", toggleMobileNav);

  document.querySelectorAll("#navmenu a").forEach((link) => {
    link.addEventListener("click", () => {
      if (body.classList.contains("mobile-nav-active")) {
        toggleMobileNav();
      }
    });
  });
});

onUnmounted(() => {
  window.removeEventListener("scroll", scrollHandler);
});
</script>

<style scoped>
/* --- ESTILOS BASE DEL NAVBAR --- */
.header {
  background: rgba(0, 0, 0, 0.85);
  transition: all 0.3s ease;
  z-index: 997;
  /* Línea roja inferior para que se note claramente que el círculo sobresale de algo */
  border-bottom: 2px solid #ff3131;
}

.scrolled-header {
  background: rgba(0, 0, 0, 0.98);
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.5);
}

.navmenu ul li a {
  font-weight: 600;
  transition: color 0.3s ease;
  color: #fff;
  text-decoration: none;
}

.navmenu ul li a:hover,
.navmenu ul li a.active {
  color: #ff3131;
}

/* --- ESTILOS DEL LOGO (MÓVIL POR DEFECTO) --- */
.logo-circle {
  background-color: #ffffff;
  /* Círculo completamente blanco */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  /* Tamaño para móvil */
  height: 55px;
  padding: 8px;
  /* Margen interno para que el logo no toque los bordes del círculo */
  transition: all 0.3s ease;
}

.logo-circle img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* --- SOLUCIÓN: Agrega este bloque para el modo Responsivo/Móvil --- */
@media (max-width: 1199px) {
  .navmenu ul li a {
    font-weight: 600;
    transition: color 0.3s ease;
    color: #000000;
    text-decoration: none;
  }

  .navmenu ul li a:hover,
  .navmenu ul li a.active {
    color: #ff3131;
  }
}

/* --- ESTILOS DE ESCRITORIO (Centrado, Pestañas a los lados y Sobresaliente) --- */
@media(min-width: 1200px) {

  /* Hacemos que la navegación ocupe todo el ancho disponible */
  .navmenu {
    width: 100%;
  }

  .navmenu ul {
    display: flex;
    width: 100%;
    align-items: center;
  }

  /* El resorte: Esto separa la lista en dos bloques, pegándolos a las orillas */
  .logo-spacer {
    flex-grow: 1;
  }

  /* Sacamos el logo del flujo normal y lo centramos matemáticamente */
  .logo-wrapper {
    position: absolute;
    left: 50%;
    bottom: 0;
    /* TranslateX(-50%) lo centra horizontalmente. TranslateY(50%) lo empuja exactamente a la mitad hacia abajo */
    transform: translate(-50%, 50%);
    z-index: 999;
  }

  /* El círculo crece en PC y le damos profundidad */
  .logo-circle {
    width: 110px;
    height: 110px;
    padding: 12px;
    box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.6);
    /* Opcional: un borde negro para darle contención contra el fondo claro que pase por detrás */
    border: 3px solid #000;
  }

  /* Comportamiento al hacer scroll en PC (hacemos el logo un poco más pequeño para que no estorbe) */
  .scrolled-header .logo-circle {
    width: 80px;
    height: 80px;
    padding: 8px;
  }
}
</style>